import { useState } from 'react';
import { JsonForms } from '@jsonforms/react';
import { materialCells } from '@jsonforms/material-renderers';

import { renderers } from '../FormRenderer';


function PreviewTab ({schema, uiSchema, formData}) {
  
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState(formData);

  function handleFormChange ({ data, errors }) {
    setData(data);
    setErrors(errors); 
  };

  console.log(schema);
  console.log(uiSchema)

  return (
    <div style={{position: "relative", left: -10}}>
      <JsonForms
        schema={schema}
        uischema={uiSchema}
        data={formData}
        renderers={renderers}
        cells={materialCells}
        //onChange={handleFormChange}
        //validationMode={validationMode}
        //ajv={customAjv}
        //i18n={{locale: locale, translate: translation}}
        //additionalErrors={errors}
      />
    </div>
  )
}

export default PreviewTab